import styles from './Question.module.css';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useState } from 'react';

import advtVideo from '../../assets/video/advt.webm';
import advtBg from '../../assets/video/advtBg.webm';

export const Question = ({ title }) => {
  const titleArr = title?.split(/\r?\n/);

  return (
    <div className={styles.questionBlock}>
      {titleArr[0] && (
        <motion.div
          initial={{ scale: 0, y: '30vh' }}
          animate={{ scale: [0, 1.57, 1], y: '0vh' }}
          transition={{
            scale: {
              duration: 0.84,
              delay: 0.6,
              times: [0, 0.8, 1],
              ease: ['easeOut', 'easeInOut'],
            },
            y: {
              delay: 1.9,
              duration: 0.36,
            },
          }}
          className={styles.firstLine}
        >
          <div>{titleArr[0]}</div>
        </motion.div>
      )}

      {titleArr[1] && (
        <div className={styles.secondLine}>
          {titleArr[1].split(' ').map((word, idx) => (
            <motion.div
              key={word + idx}
              initial={{ scale: 0 }}
              animate={{
                scale: [0, 1.15, 1],
                opacity: 1,
                transition: {
                  opacity: { duration: 0.6, delay: 5 },
                  scale: {
                    duration: 0.48,
                    delay: idx * 0.5 + 2.88,
                    times: [0, 0.75, 1],
                    ease: ['easeOut', 'easeInOut'],
                  },
                },
              }}
            >
              {word}
            </motion.div>
          ))}
        </div>
      )}

      {titleArr[2] && (
        <div className={styles.thirdLine}>
          {titleArr[2].split(' ').map((word, idx) => (
            <motion.div
              key={word + idx}
              initial={{ scale: 0 }}
              animate={{
                scale: [0, 1.15, 1],
                opacity: 1,
                transition: {
                  opacity: { duration: 0.6, delay: 5 },
                  scale: {
                    duration: 0.48,
                    delay: idx * 0.5 + 4.12,
                    times: [0, 0.75, 1],
                    ease: ['easeOut', 'easeInOut'],
                  },
                },
              }}
            >
              {word}
            </motion.div>
          ))}
        </div>
      )}

      {titleArr[3] && (
        <motion.div
          initial={{ y: '50vh', opacity: 0 }}
          animate={{
            y: '0',
            opacity: 1,
          }}
          transition={{ duration: 1.48, delay: 5.2 }}
          className={styles.fourthLine}
        >
          <div>{titleArr[3]}</div>
        </motion.div>
      )}

      <video
        autoPlay="autoplay"
        muted="muted"
        playsInline
        id="bgVideo"
        style={{ zIndex: '-98' }}
      >
        <source src={advtVideo} type="video/webm"></source>
      </video>
      <video
        autoPlay="autoplay"
        muted="muted"
        playsInline
        id="bgVideo"
        loop
        style={{ zIndex: '-99' }}
      >
        <source src={advtBg} type="video/webm"></source>
      </video>
    </div>
  );
};
